//* 오픈일(11/1)부터 30일째 끝까지만 「신규」를 단다(기획 3-6 newbadge_days 30).
const AFFILIATE_NEW_BADGE_END_AT = Date.parse('2026-11-30T23:59:59+09:00');

export const isAffiliateNewBadgeVisible = (now = new Date()) =>
  now.getTime() <= AFFILIATE_NEW_BADGE_END_AT;
